<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Pasajes lista</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/pasajes/tickets/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear pasaje </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Codigo</th>
                  <th>Reponsable</th>
                  <th>Teléfonos</th>
                  <th class="text-center">Total</th>
                  <th class="text-center">Pagado</th>
                  <th class="text-center">Deuda</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a class="grid__link nowrap" (click)="detail(item.id)">
                        <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite"></i>
                        {{item.code}}
                      </a>
                    </td>
                    <td>
                      <p class="m-b-0" style="line-height: 1.3em;">{{item.client_data.fullname}}</p>
                      <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} : {{item.client_data.document}}</p>
                    </td>
                    <td>
                      <div>{{item.client_data.cellphone}}</div>
                      <div *ngIf="item.client_data.telephone != null">
                        {{item.client_data.telephone}}
                      </div>
                    </td>
                    <td class="text-center nowrap">
                      {{toolsService.momeySol()}}{{item.total}}
                    </td>
                    <td class="text-center nowrap">
                      <span class="text-primary">{{toolsService.momeySol()}}{{item.total_paid}}</span>
                    </td>
                    <td>
                      <span class="text-center text-danger nowrap bold">
                        {{toolsService.momeySol()}}{{(item.total - item.total_paid).toFixed(2)}}
                      </span>
                    </td>

                    <td class="text-center">
                      <a class="btn p-5 pointer text-danger bold" (click)="delete(item, i)">
                        <i class="far fa-trash-alt"></i>
                      </a>
                      <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                        <i class="fas fa-pencil-alt"></i>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
